<template>
  <a-modal
    :title="status == 1 ? '详情' : '编辑'"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    @ok="handleSubmit"
    :cancelButtonProps="{ props: { disabled: true } }"
    :maskClosable="false"
    :footer="null"
  >
    <a-form :form="form" :class="status == 1 ? 'readyOnly' : ''">
      <a-form-item style="display:none">
        <a-input v-decorator="['brandId']" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="产品类别">
        <a-select v-decorator="['installType', { rules: [{ required: true, message: '请选择产品类别' }] }]">
          <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="品牌名称">
        <a-input v-decorator="['brandName', { rules: [{ required: true, message: '请输入品牌名称' }] }]" />
      </a-form-item>
    </a-form>
    <a-row :class="status == 1 ? 'readyOnly' : ''" v-if="status != 1">
      <a-col :span="12" :offset="6" style="text-align: center">
        <a-button @click="handleContinueSubmit()" v-if="brand == 1" type="primary" style="margin-right: 8px"
          >保存并继续添加</a-button
        >
        <a-button @click="handleSubmit" type="primary" style="margin-right: 8px;">保存</a-button>
        <a-button @click="showModal">取消</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>
<script>
import { saveBrand } from '@/api/enterprise/brand'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'

export default {
  name: 'BrandModal',
  props: {},
  components: {},
  data() {
    return {
      queryParam: {},
      visible: false,
      // getDictionaryList: [],
      queryParamslist: {},
      restaurantOperTypeMap: {},
      restaurantTypes: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      brand: 0,
      status: 0
    }
  },
  beforeCreate() {},
  async created() {
    this.restaurantTypes = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
  },
  mounted() {},
  methods: {
    showModal() {
      this.visible = !this.visible
    },
    add() {
      this.form.resetFields()
      this.edit({ brandId: 0 })
      this.brand = 1
    },
    edit(record, status) {
      this.status = status
      this.brand = 0
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.mdl, 'brandId', 'brandName', 'installType'))
        // console.log(brandId)
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          saveBrand(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                if (values.brandId == 0) {
                  this.$emit('ok', 1)
                } else {
                  this.$emit('ok', 2)
                }

                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    handleContinueSubmit(e) {
      // e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          saveBrand(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok')
                this.edit({ brandName: '' })
                this.brand = 1
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
          // this.queryParamslist = {}
        }
      })
    }
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>

<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  padding: 4px 16px !important;
}
.readyOnly {
  pointer-events: none;
}
</style>
